import type { ReactNode } from 'react'
import { getExperiencePriceCategoryLabel } from '@/lib/experience/price-category-label'

import type { SelectedOptions } from '../_lib/experience-state-types'
import type { VariantOption } from './use-app-experience-options'

type UseAppExperiencePersonsLabelProps = {
  allOptions: VariantOption[]
  selectedOptions: SelectedOptions | null
  fallback: ReactNode
}

export function useAppExperiencePersonsLabel({
  allOptions,
  selectedOptions,
  fallback,
}: UseAppExperiencePersonsLabelProps) {
  selectedOptions = selectedOptions ?? {}

  const optionsWithLabel = allOptions.filter(option => option.id in selectedOptions)

  if (optionsWithLabel.length === 0) {
    return fallback
  }

  return optionsWithLabel
    .map(
      option => `${selectedOptions[option.id]} x ${getExperiencePriceCategoryLabel(option.name)}`
    )
    .join(', ')
}
